import { POST, GET } from 'src/network/apiHandler';
import config from 'src/globals';
import {
    MARK_CONSIGNMENT_UNDELIVERED_IST,
    MARK_CONSIGNMENT_DELIVERED_IST,
    INVOICE_SEARCH_IST,
    GET_TASK_SIGNED_URL,
} from 'src/api/routes';

const { API_BASE_URL } = config;

export const getInvoiceNumbersForIST = async (data: any) => {
    return GET(`${API_BASE_URL}${INVOICE_SEARCH_IST}`, data);
};

export const markConsignmentsAsDeliveredForIST = async (data: any) => {
    return POST(`${API_BASE_URL}${MARK_CONSIGNMENT_DELIVERED_IST}`, data);
};

export const markConsignmentsAsUndeliveredForIST = async (data: any) => {
    return POST(`${API_BASE_URL}${MARK_CONSIGNMENT_UNDELIVERED_IST}`, data);
};

export const uploadImages = async (files: any) => {
  return POST(
    `${API_BASE_URL}${GET_TASK_SIGNED_URL}`,
    {
      types: files.map((f) => f.type?.split('/')?.[1]),
    },
  );
};
